import { setContext } from "@apollo/client/link/context";
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import Cookies from "universal-cookie";

import { AUTH_TOKEN } from "./CONSTANTS";
import { GRAPHQL_ENDPOINT } from "./API";

const cookies = new Cookies();

export const createClient = () => {
  const authLink = setContext((_, { headers }) => {
    const token = cookies.get(AUTH_TOKEN);
    return {
      headers: {
        ...headers,
        authorization: token ? `JWT ${token}` : "",
      },
    };
  });
  const httpLink = createHttpLink({
    uri: GRAPHQL_ENDPOINT,
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
    connectToDevTools: true,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
      },
    },
  });
  return client;
};
